import { MatSnackBarConfig } from '@angular/material/snack-bar';

enum ToastStyle {
  ERROR = 'mat-snack-bar-container-error'
}

export const config: MatSnackBarConfig = {
  verticalPosition: 'bottom',
  horizontalPosition: 'right',
  panelClass: ToastStyle.ERROR,
  duration: 25000 // in millisec
};
